var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 10,
    transform: "matrix(0.999914 0.0130896 0 1 0 0)",
    fill: "#E5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6594 23.3221L44.8335 26.5352C47.1887 27.455 47.1887 28.9757 44.8335 29.8955L36.6594 33.1087C35.7311 33.4766 34.2072 33.4766 33.2789 33.1087L25.1048 29.8955C22.7496 28.9757 22.7496 27.455 25.1048 26.5352L33.2789 23.3221C34.2072 22.9542 35.7311 22.9542 36.6594 23.3221Z",
    stroke: "#009FFF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0459 33.3845C22.0459 34.4005 22.9505 35.5736 24.0562 35.9849L33.8059 39.6374C34.5526 39.9156 35.3997 39.9156 36.1321 39.6374L45.8818 35.9849C46.9874 35.5736 47.8921 34.4005 47.8921 33.3845",
    stroke: "#009FFF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0459 39.8462C22.0459 40.971 22.8356 41.9869 24.0562 42.4465L33.8059 46.0991C34.5526 46.3773 35.3997 46.3773 36.1321 46.0991L45.8818 42.4465C47.1023 41.9869 47.8921 40.971 47.8921 39.8462",
    stroke: "#009FFF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 56H40.3C50.8 56 55 51.8 55 41.3V28.7C55 18.2 50.8 14 40.3 14H27.7C17.2 14 13 18.2 13 28.7V41.3C13 51.8 17.2 56 27.7 56Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.59124f0f401e537136aa26318401ff92.svg";
export { ForwardRef as ReactComponent };